module.exports = __webpack_public_path__ + "img/code.a09e1e6d.png";